export default __webpack_public_path__ + "static/media/send.60bdcda6.svg";